/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isArrayNotEmpty } from "utils/empty-exists";
// import axios from "axios";

const useZencity = () => {

    const { token } = useAuth();
    const [projects, setProjects] = useState(undefined);
    // const [topics, setTopics] = useState(undefined)

    // const makeZencityRequest = async (method, url, data) => {
    //     const config = {
    //         method,
    //         url,
    //         headers: { "Content-Type": "application/vnd.api+json" },
    //         data: data,
    //     };
    //     const response = await axios(config);
    //     return response.data;
    // };
    const loadProjects = async () => {
        if (!projects || !projects?.length) {
            const project_response = await SimpliCityAdminSDK.services.zencity.getProjects(token);
            if(isArrayNotEmpty(project_response)) {
                project_response.reverse();
            }
            setProjects(project_response);
        }
    };
    const getProject = async (id) => {
        try {
            if (!id) {
                return undefined;
            }
            return await SimpliCityAdminSDK.services.zencity.getProject(token, id);
        } catch (error) {
            console.error(error);
        }
    };

    // const loadEngagements = async () => {
    //     const host = 'https://local.simplicitycms.ca:4001'
    //     const _topics = await makeZencityRequest(
    //         'GET', `${host}/services/zencity/engagements`
    //     )
    //     setTopics(_topics)
    // }
    loadProjects();
    return {
        projects, 
        // topics,
        getProject,
    };

};

export { useZencity };
